<template>
  <v-tabs centered color="cyan" dark icons-and-text>
    <v-tabs-slider color="yellow"></v-tabs-slider>

    <v-tab href="#tab-1" @click.prevent="setTaskByUser(currentUser.id)">
      Minhas Tarefas
      <v-icon>assignment</v-icon>
    </v-tab>

    <v-tab
      href="#tab-2"
      @click.prevent="setTaskByDepartament(currentUser.departments)"
    >
      Meus Departamentos
      <v-icon>inbox</v-icon>
    </v-tab>

    <v-tab-item v-for="i in 2" :key="i" :value="'tab-' + i">
      <v-list v-if="tasks" two-line>
        <template v-for="(item, index) in tasks">
          <v-list-tile :key="item.departament" avatar>
            <v-list-tile-action @click="setSelected(index)" ripple>
              <v-icon :color="item.status === 'closed' ? 'green' : 'grey'">{{
                item.status | taskStatus
              }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title
                v-html="item.departament_id"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="item.priority + ' | ' + item.content"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action @click="setResponsible(index)" ripple>
              <v-list-tile-action-text>{{
                item.due | formatarDate
              }}</v-list-tile-action-text>
              <v-icon
                v-if="item.responsible_id != currentUser.id"
                color="grey lighten-1"
                >star_border</v-icon
              >
              <v-icon v-else color="yellow darken-2">star</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 < tasks.length" :key="index"></v-divider>
        </template>
      </v-list>
    </v-tab-item>
  </v-tabs>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  async mounted() {
    // if(this.tasks.length <= 0) {
    await this.getTasksByParam({
      id: this.currentUser.id,
      type: "responsible",
    });
    // }
    // this.tasksList = this.tasks
    // console.log("tasks: ", this.tasks)
  },
  computed: {
    ...mapState(["currentUser"]),
    ...mapState("cs", ["tasks"]),
  },
  methods: {
    ...mapActions("cs", [
      "getTasksByParam",
      "setSelectedTask",
      "updateTaskResponsible",
    ]),
    async setTaskByDepartament(department_ids) {
      if (!department_ids) {
        alert("Erro: Departamentos do usuário não encontrados");
        return;
      }
      // console.log("departament: ", department_ids)
      await this.getTasksByParam({ id: department_ids, type: "departament" });
    },
    async setTaskByUser(user_id) {
      // console.log("user: ", user_id)
      await this.getTasksByParam({ id: user_id, type: "responsible" });
    },
    setResponsible(index) {
      // console.log("set this user responsible", this.currentUser, "for", this.tasks[index])
      if (this.tasks[index].responsible_id != null) {
        // console.log("already has responsible")
      } else {
        this.updateTaskResponsible({
          task: this.tasks[index],
          responsible_id: this.currentUser.id,
          responsible_name: this.currentUser.name,
        });
      }
    },
    async setSelected(index) {
      // console.log("set selected", index, this.tasks[index])
      await this.setSelectedTask({ task: this.tasks[index] });
    },
  },
  filters: {
    taskStatus(value) {
      if (!value) return "error";
      else if (value === "closed") return "check_circle_outline";
      else if (value === "waiting_customer") return "hourglass_empty";
      else if (value === "in_attendance") return "forum";
      else return "schedule";
    },
  },
};
</script>
